import React from 'react';
import CarouselServicos from '../components/carouselServicios';
import FloatingButton from '../components/buttonFlotanteWha';

import Gallery from '../components/gallery';
import "./styles.css"
import CMP1 from "../assets/images/certi/cmp1.jpg"
import CMP2 from "../assets/images/certi/cmp2.jpg"
import CMP3 from "../assets/images/certi/cmp3.jpg"
import CMP4 from "../assets/images/certi/cmp4.jpg"
import CGI1 from "../assets/images/certi/cgi1.jpg"
import CGI2 from "../assets/images/certi/cgi2.jpg"
import CGI3 from "../assets/images/certi/cgi3.jpg"
import CGI4 from "../assets/images/certi/cgi4.jpg"
import CMA1 from "../assets/images/certi/cma1.jpg"
import CMA2 from "../assets/images/certi/cma2.jpg"
import CMA3 from "../assets/images/certi/cma3.jpg"
import CMA4 from "../assets/images/certi/cma4.jpeg"
import CSM1 from "../assets/images/certi/csm1.jpg"
import CSM2 from "../assets/images/certi/csm2.jpg"
import CSM3 from "../assets/images/certi/csm3.jpg"
import CSM4 from "../assets/images/certi/csm4.jpg"
import CI1 from "../assets/images/certi/ci1.jpg"
import CI2 from "../assets/images/certi/ci2.jpg"
import CI3 from "../assets/images/certi/ci3.jpg"
import CI4 from "../assets/images/certi/ci4.jpg"
import CEL1 from "../assets/images/certi/cel1.jpg"
import CEL2 from "../assets/images/certi/cel2.jpg"
import CEL3 from "../assets/images/certi/cel3.jpg"
import CEL4 from "../assets/images/certi/cel4.jpg"
import CMC1 from "../assets/images/certi/cmc1.jpg"
import CMC2 from "../assets/images/certi/cmc2.jpg"
import CMC3 from "../assets/images/certi/cmc3.jpg"
import CMC4 from "../assets/images/certi/cmc4.png"
import CTG1 from "../assets/images/certi/ctg1.jpg"
import CTG2 from "../assets/images/certi/ctg2.jpg"
import CTG3 from "../assets/images/certi/ctg3.jpg"
import CTG4 from "../assets/images/certi/ctg4.jpg"



const imagenes= [CMP1,CMP2,CMP3,CMP4];
const imagenes2=[CGI1,CGI2,CGI3,CGI4];
const imagenes3=[CMA1,CMA2,CMA3,CMA4];
const imagenes4=[CSM1,CSM2,CSM3,CSM4];
const imagenes5=[CI1,CI2,CI3,CI4];
const imagenes6=[CEL1,CEL2,CEL3,CEL4];
const imagenes7=[CMC1,CMC2,CMC3,CMC4];
const imagenes8=[CTG1,CTG2,CTG3,CTG4];


function Certificaciones(){
    return(
        <div className="fflex flex-col items-center p-10 space-y-10 min-h-screen animated-background">
            <CarouselServicos/>


            <div className='flex flex-col items-center text-center w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
            CERTIFICACIONES
            </h1>
            <div className='bg-oro h-1 w-44 my-3'></div>
            <p className='text-gris-oscuro font-medium text-lg'>
            Somos especialistas en la certificación de equipo pesado de la Minería y Construcción de grúas industriales, en la certificación de operadores, Rigger, supervisores de seguridad. Equipos de Izáje.
            </p>
          </div>



 <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
        {/* Galería de imágenes con altura igual */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[400px]">
            <Gallery titulo="CERTIFICACIÓN DE MAQUINARIAS PESADA DE MINERIA Y CONSTRUCCION" imagenes={imagenes} />
        </div>

        {/* Sección de Descripción con altura igual */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg text-justify text-gris-oscuro leading-relaxed min-h-[400px] flex flex-col justify-center">
           
            <p>
            Con el propósito de colaborar con nuestros clientes en alcanzar la mayor confiabilidad de su máquina para la construcción proveemos servicio de certificación y verificación, enfocándonos en los equipos para el movimiento de tierras de la minería y la construcción en los cálculos de resistencia y estabilidad conforme a las normas vigentes Nacionales e internacionales. Certificación de maquinaria para el movimiento de tierra: Las exigencias operacionales en seguridad, salud y ambiente y responsabilidad social; obligan al correcto mantenimiento de los equipos con el objetivo de no tener paradas innecesarias durante la operación y no afectar la producción y así alcanzar las metas de producción trazadas. Contamos con Inspectores Calificados y Certificados por Agencia de Certificación reconocida a nivel mundial. Nuestros instrumentos tecnológicos son de última generación de forma que podamos verificar y garantizar el correcto y seguro funcionamiento de sus equipos. Las inspecciones constituyen nuestra fortaleza para controlar los requerimientos establecidos en los contratos de alquiler, venta de equipos (Mantenimiento preventivo y correctivo), y los riesgos asociados a las operaciones. Los son la base para realizar las inspecciones, verificación y certificación de los equipos Pesados ya que ellos estarán orientados a verificar el cumplimiento de los mantenimientos programados, preventivos y correctivos. El programa de inspecciones de equipos se basa a las normativas <strong> ASME B 30.26, B30.20, B30.10, B30.09, OSHA.</strong> Y en nuestra experiencia en las normas de inspección de equipos. Nuestro personal técnico ha sido capacitado, entrenado, evaluado, certificado y autorizado para realizar inspecciones y certificaciones de equipos. Las inspecciones a equipos y vehículos, considera la trayectoria del equipo y a qué tipo de inspecciones debe someterse o han sido sometidos en el transcurso de su uso, esto considera lo siguiente:
            </p>
          
            <h3 className="text-lg font-semibold text-azul-oscuro mt-4">Tipos de Inspección</h3>
            <ul className="list-disc list-inside">
                <li>Inspección General</li>
                <li>Inspección Pre-uso, Rutinaria y Sistemática</li>
                <li>Inspección de Sistemas Hidráulico, Neumático y Eléctrico</li>
                <li>Inspección del Compartimiento del Operador</li>
                <li>Inspección de Cumplimiento de Requerimientos Legales</li>
                <li>Verificación del Programa de Mantenimiento</li>
            </ul>
            <h3 className="text-lg font-semibold text-azul-oscuro mt-4">Equipos que Certificamos</h3>
            <ul className="list-disc list-inside">
                <li>Motoniveladoras</li>
                <li>Excavadoras Hidráulicas</li>
                <li>Bulldozers</li>
                <li>Cargadores Frontales</li>
                <li>Retroexcavadoras</li>
                <li>Rodillos Compactadores</li>
                <li>Mini Cargadores</li>
                <li>Perforadoras</li>
                <li>Chancadoras</li>
                <li>Camiones Articulados y Fuera de Carretera</li>
                <li>Palas Hidráulicas y Eléctricas</li>
                <li>Otros equipos especializados</li>
            </ul>
            
        </div>
    </div>
</div>




    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          Ofrecemos servicio de inspección, verificación y certificación para todo tipo de grúas industriales. Nuestra experiencia nos permite garantizar la aplicación de los más altos estándares en las verificaciones que realicemos de la mano con la experiencia de nuestros técnicos, ingenieros que integran nuestro equipo. Cecomp Training ofrece el servicio de certificación de grúas la inspección implica los siguientes alcances. Verificar que los certificados de prueba y otra documentación de mantenimiento cumplan con las normas aplicables. Verificar que las formas de acceso (escalera de mano, pasillos, etc.) están en condiciones satisfactorias. Verificar que la identificación y marca son claramente visibles, extensiones de radio y rango de operación. Identificar las deformaciones debido a golpes o tensiones excesivas, corrosiones, montajes inapropiados, etc., durante la verificación de la estructura. Cuando se requiera, se realiza el desmantelamiento de algún elemento, y posteriormente se re ensambla por personal experimentado bajo las responsabilidades del dueño del Equipo.
          </p>

          {/* 📌 Lista de Temas */}
          <h3 className="text-lg font-semibold  mb-2">
          Grúas a Certificar:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Certificación de GrúasEstructurales
            </li>
            <li>Certificación de Grúas Hidráulicas Telescópicas</li>
            <li>Certificación de Grúas Hidráulicas Articuladas</li>
            <li>Certificación de Grúas Puente (viajeras)
            </li>
            <li>Certificación de Grúas Torre</li>
            <li>Certificación de Grúas Gantry</li>
            <li>Certificación de Grúas para Plataformas Marinas (offshore)</li>
            
          </ul>

        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="CERTIFICACIÓN DE TODO TIPO DE GRÚAS INDUSTRIALES" imagenes={imagenes8} />
        </div>  
      </div>
    </div>



    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl gap-6 md:gap-8">
        
        {/* Galería de imágenes - Misma altura que el texto */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex flex-col h-full">
            <Gallery 
                titulo="CERTIFICACION DE MAQUINARIA AGRICOLA" 
                imagenes={imagenes3}
                className="h-full flex-grow"
            />
        </div>

        {/* Sección de Descripción - Misma altura que galería */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg flex flex-col h-full">
            <div className="text-gris-oscuro leading-relaxed text-justify flex-grow overflow-auto">
                <p className="mb-4">
                Asegúrese que sus equipos cumplen con las especificaciones, configuraciones de acuerdo a la geografía de la región en donde se pretenden operar, proveemos la inspección, verificación y pruebas necesarias para la obtención de la certificación de la buena operatividad de maquinaria agrícola.
                </p>
                
              
            </div>
        </div>
    </div>
</div>



<div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          A través de estándares establecidos para medir el conocimiento y la competencia requeridos para la operación segura de maquinaria pesada los candidatos pueden acceder a esta certificación. De esta forma aseguramos las capacidades de los operadores para la reducción de riesgos a través de prácticas seguras estandarizadas.
          </p>

          {/* 📌 Lista de Temas */}
          <h3 className="text-lg font-semibold  mb-2">
          Certificación de Operadores de Elevadores de Personal y Carga de Materiales, tales como:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Certificación de Operadores de Manlift.
            </li>
            <li>Certificación de Operadores de Forklift.</li>
            <li>Certificación de Operadores de Telehandler.</li>
            <li>Certificación de Operadores de Grúas Articuladas.
            </li>
            <li>Certificación de Operadores de Grúas telescópicas.</li>
            <li>Certificación de Operadores de Estructurales, Viajeras, Pórtico, Polipastos, Torre, etc.</li>
          </ul>

        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="CERTIFICACION DE OPERADORES DE TODO TIPO DE GRUAS INDUSTRIALES" imagenes={imagenes2} />
        </div>  
      </div>
    </div>



<div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
        {/* Galería de imágenes con altura igual */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[400px]">
            <Gallery titulo="CERTIFICACIÓN DE SUPERVISORES DE MANIOBRA" imagenes={imagenes4} />
        </div>

        {/* Sección de Descripción con altura igual */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg text-justify text-gris-oscuro leading-relaxed min-h-[400px] flex flex-col justify-center">
           
            <p>
            Para aquellos quienes requieran certificar su experiencia en la supervisión de maniobras habrán de demostrar el dominio de materias específicas entre las que se encuentran la planeación de alto nivel, la evaluación de riesgos y de métodos para llevar a cabo las operaciones de elevación de forma segura.
            </p>
          
          
        </div>
    </div>
</div>


<div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          Certificamos y determinamos las capacidades de los elementos de Izáje, realizando pruebas físicas. Sometemos estos elementos a cargas de hasta 125% su capacidad nominal para verificar su integridad estructural y mecánica. Tras una inspección favorable un informe es expedido por nuestro personal calificado.
          </p>

        
        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="CERTIFICACIÓN DE ELEMENTOS DE IZAJE" imagenes={imagenes5} />
        </div>  
      </div>
    </div>

    








    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
        {/* Galería de imágenes con altura igual */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[400px]">
            <Gallery titulo="CERTIFICACION DE EQUIPOS DE LEVANTE" imagenes={imagenes6} />
        </div>

        {/* Sección de Descripción con altura igual */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg text-justify text-gris-oscuro leading-relaxed min-h-[400px] flex flex-col justify-center">
           
            <p>
            Contamos con el servicio de certificación de montacargas y plataformas de carga. Efectuamos la examinación y los test necesarios para certificar el estado operativo de estos equipos conforme a las normas internacionales (o locales) vigentes. Nuestro objetivo con el servicio de certificación de equipos de levante es asegurarle que su equipos cumplen con los estándares, exigimos por las legislaciones locales. Tomamos muy enserio nuestro trabajadores por lo que todos nuestro elemento humanos de certificación son regularmente auditados para asegurar los más altos niveles de competencia.
            </p>
          
            <h3 className="text-lg font-semibold text-azul-oscuro mt-4">Equipos de levante a certificar</h3>
            <ul className="list-disc list-inside">
                <li>Certificación de Elevadores de Personal y Carga de Materiales, tales como.</li>
                <li>Certificación de Manlift.</li>
                <li>Certificación de Forklift.</li>
                <li>Certificación de Telehandler, etc.</li>
                <li>Certificación de Grúas Articuladas, Hidráulicas.</li>
                <li>Certificación de Grúas telescópicas.</li>
                <li>Certificación de Estructurales, Viajeras, Pórtico, Polipastos, Torre, etc.</li>
            </ul>
            
            
        </div>
    </div>
</div>
          



<div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4 text-justify">
          A través de estándares establecidos para medir el conocimiento y la competencia requeridos para la operación segura de maquinaria pesada los candidatos pueden acceder a esta certificación. De esta forma aseguramos las capacidades de los operadores para la reducción de riesgos de accidentes a través de prácticas seguras estandarizadas.
          </p>

        
        
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="CERTIFICACION DE OPERADORES DE MAQUINARIA PARA LA CONSTRUCCIÓN" imagenes={imagenes7} />
        </div>  
      </div>
    </div>

          
<FloatingButton/>
       
        </div>
        
    );
}
export default Certificaciones;